export const CHARGE_CODE_RETURN_INTENT_KEY = 'chargeCodeReturnIntent';

/** Stored before navigating to the enter-charge-code page. */
export interface ChargeCodeReturnIntent {
  returnRoute: string;
  backTo: string;
  chargerId: string;
  clearBookingOnBack?: boolean;
  /** User is already on a checkout screen; go straight to returnRoute after unlock. */
  resumeCheckoutOnly?: boolean;
}
